import { RewardsAccount } from "redmond";

export const PRESIDENTS_CIRCLE = "presidentsCircle" as const;
export const FIVE_STAR = "fiveStar" as const;

export type HertzTier = typeof PRESIDENTS_CIRCLE | typeof FIVE_STAR;

export type HertzTierStatus = { tier: HertzTier; cardName: string; caponeProduct: string } | null;

const PRESIDENTS_CIRCLE_PRODUCTS = ["VentureX", "VentureXBusiness"];

const FIVE_STAR_PRODUCTS = [
  "Venture",
  "VentureBusiness",
  "VentureOne",
  "VentureOneBusiness",
  "Quicksilver",
  "QuicksilverOne",
  "Savor",
  "SavorOne",
  "SparkMiles",
  "SparkMilesSelect",
];

// Hertz loyalty tier mapping
// caponeProduct values are stable enum names from Tysons CapOneProduct enum.
// Mirrors b2bportal/libs/core/cars/.../LoyaltyPill/useLoyaltyPill.ts — keep these arrays in sync.
export const determineHertzTierStatus = (rewardsAccounts: RewardsAccount[]): HertzTierStatus => {
  const presidentsCircleAccount = rewardsAccounts.find(
    (account) =>
      account.caponeProduct != null &&
      PRESIDENTS_CIRCLE_PRODUCTS.some(
        (product) => product.toLowerCase() === account.caponeProduct!.toLowerCase()
      )
  );

  if (presidentsCircleAccount != null) {
    return {
      tier: "presidentsCircle",
      cardName: presidentsCircleAccount.productDisplayName,
      caponeProduct: presidentsCircleAccount.caponeProduct!,
    };
  }

  const fiveStarAccount = rewardsAccounts.find(
    (account) =>
      account.caponeProduct != null &&
      FIVE_STAR_PRODUCTS.some(
        (product) => product.toLowerCase() === account.caponeProduct!.toLowerCase()
      )
  );

  if (fiveStarAccount != null) {
    return {
      tier: "fiveStar",
      cardName: fiveStarAccount.productDisplayName,
      caponeProduct: fiveStarAccount.caponeProduct!,
    };
  }

  return null;
}